import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  padding:15px 0;
  font-size: 17px;
  color:#2196f3;
  padding-top:25px;
`;
const SectionHeader = ({ children }) => (
  <StyledDiv>{children}</StyledDiv>
);
export default SectionHeader;
